import { FC, useEffect, useState } from "react";
import { motion } from "framer-motion";
import classes from "./Loader.module.scss";

interface LoaderProps {
	setIsLoading: (isLoading: boolean) => void;
}

export const Loader: FC<LoaderProps> = ({ setIsLoading }) => {
	const [isVisible, setIsVisible] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsVisible(false);
			setIsLoading(false);
		}, 2000);

		return () => {
			clearTimeout(timer);
		};
	}, [setIsLoading]);

	return (
		<>
			{isVisible && (
				<div className={classes.loader}>
					<motion.img
						className={classes.image}
						src="images/gamepad-4.png"
						animate={{ rotate: 360 }}
						transition={{ duration: 2, loop: Infinity }}
					/>
				</div>
			)}
		</>
	);
};
